// Browser polyfills
import 'babel-polyfill';
import 'whatwg-fetch';
import 'url-search-params-polyfill';
import 'scroll-restoration-polyfill';
import 'core-js/fn/object/values'; // Object.values not implemented in IE
// import Intl from 'intl'; // eslint-disable-line no-unused-vars

// Libs
import React from 'react';
import { render } from 'react-dom';
import { Provider, connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Router } from 'react-router';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import classNames from 'classnames';

//Components
import Header from './components/shared/header';
import Footer from './components/shared/footer';
import Modal from './components/shared/modal/modal.jsx';
import CookieNotice from './components/shared/cookie-notice/cookie-notice.jsx';
import ActivityIndicator from './components/shared/activity-indicator/activity-indicator.jsx';
import LocaleString from './components/shared/locale-string';

// Redux
import { fetchClientData, getSessionBundleData } from './client-dux';
import { fetchCatalogUrl } from './catalog-dux';
import { getSessionUserData, savePrivacyAcknowledgment } from './user-dux.js';
import AppStore from './app-store';

// Utils
import appHistory from './history';
import Errors from './errors';
import Locale from './locale';

// Routes
import routes from './app-routes.js';

import './themes/style.scss';



/*******************************************************************************
 *  1. App (root level component)
 */

class App extends React.Component {

    constructor( props ) {
        super( props );
        this.state = {
            invalidatedRoute: '',
            validatedRoute: '',
            validRoute: false,
            gaInitialized: false,
            loaded: false,
            shopRedirect: false,
            shopRedirectError: false
        };
    }

    UNSAFE_componentWillMount() {//eslint-disable-line
        this.props.fetchClientData().then( () => {
            this.props.getSessionBundleData( this.props.clientData.bundleList ).then( () => {
                this.props.getSessionUserData( this.props.clientData.locale ).then( () => {
                    this.setState( { loaded: true } );
                } );
            } );
        } );
    }

    UNSAFE_componentWillReceiveProps( nextProps ) {//eslint-disable-line
        if ( nextProps.userData && nextProps.userData.isInActiveHasPoints ) {
            if ( !this.state.shopRedirect ) {
                this.setState( { shopRedirect: true } );
                this.handleShopRedirect();
            }
        }
    }

    render() {
        const loaded = this.state.loaded;
        const {
            userData,
            authenticated,
            dispatch,
            errors,
            ssoAuthenticated
        } = this.props;

        if ( userData && userData.isInActiveHasPoints ) {
            return (
                <div className="app-container">
                    <div className="error-page">
                        <div className="content-container">
                            <p>
                                { this.state.shopRedirectError &&
                                    <LocaleString code="home.content.catalogDownMessage" />
                                }
                            </p>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <Router history={ appHistory }>
                    { ( errors.length > 0 && appHistory.location.pathname !== '/error' ) ?
                        <Redirect to="/error" push />
                        :
                        <Route render={
                            ( props ) =>
                                <AppRoute { ...props }
                                    loaded={ loaded }
                                    authenticated={ authenticated }
                                    dispatch={ dispatch }
                                    userData={ userData }
                                    ssoAuthenticated={ ssoAuthenticated }
                                />
                        } />
                    }
                </Router>
            );
        }
    }

    handleShopRedirect = () => {
        this.props.fetchCatalogUrl( 'merchandise' )
            .then( catalogUrl => {
                window.location.href = catalogUrl;
            } )
            .catch( () => {
                this.setState( { shopRedirectError: true } );
            } );
    };
}

class AppRoute extends React.Component {
    previousLocation = null;
    previousScrollY = 0;
    locationHistory = [];

    componentDidMount() {
        history.scrollRestoration = 'manual';

        //pre-load routes
        const preLoadRoutes = [ ...routes ].filter( route => route.preLoadPriority !== undefined );

        preLoadRoutes.sort( ( a, b ) => {
            const x = a.path == this.props.location.pathname ? -1 : a.preLoadPriority || 100;
            const y = b.path == this.props.location.pathname ? -1 : b.preLoadPriority || 100;

            return +( x > y ) || +( x === y ) - 1;
        } ).forEach( ( route ) => {
            this.isRouteLoaded( route.path, true );
        } );
    }

    shouldComponentUpdate( nextProps ) {
        const { location, history, authenticated, loaded, ssoAuthenticated } = this.props;

        // 'Look at 'back' (POP) actions to
        //   1. Prevent transitioning to unauthorized routes
        //   2. Dismiss all open modals.
        if ( ( history.action === 'POP' || !loaded ) && location.pathname !== history.location.pathname ) {
            const fromRoute = routes.find( ( route ) => this.doPathsMatch( route.path, location.pathname ) );
            const toRoute = routes.find( ( route ) => this.doPathsMatch( route.path, history.location.pathname ) );

            if ( fromRoute && toRoute ) {
                if ( ( authenticated && !toRoute.allowAuthenticated ) || ( !authenticated && !toRoute.allowAnonymous ) ) {
                    appHistory.replace( location.pathname );
                    return false;

                } else if ( fromRoute && toRoute && fromRoute.modal && toRoute.modal ) {
                    //look in location history to make sure the user didn't press the forward button in the browser.
                    const fromIndex = this.locationHistory.findIndex( ( loc ) => loc.key === location.key );
                    const toIndex = this.locationHistory.findIndex( ( loc ) => loc.key === history.location.key );

                    if ( toIndex < fromIndex ) {
                        appHistory.goBack();
                        return false;
                    }
                } else if ( !authenticated && this.locationHistory.length < 2 && toRoute.path !== '/login' ) {
                    //handle the situation where the user starts on a modal and he/she is not logged in.
                    appHistory.replace( '/login' );
                    return false;
                }
            }
        }

        // If the page isn't event loaded yet, prevent unauthorized routes from being rendered. PageRoute
        // will redirect, but that causes the page animation to execute when the app is still loading.
        if ( !loaded && nextProps.loaded ) {
            const route = routes.find( ( route ) => this.doPathsMatch( route.path, history.location.pathname ) );

            if ( route ) {
                if ( nextProps.authenticated && !route.allowAuthenticated ) {
                    appHistory.replace( '/home' );

                    return false;
                } else if ( !nextProps.authenticated && !route.allowAnonymous && location.pathname === history.location.pathname ) {

                    if ( !!sessionStorage.getItem( 'sessionTimedOut' ) && ssoAuthenticated.ssoLogoutType !== 'login' ) {
                        sessionStorage.removeItem( 'sessionTimedOut' );
                        appHistory.replace( '/sso-logout' );
                    } else {
                        appHistory.replace( '/login' );
                    }

                    return false;
                }
            } else {
                if ( nextProps.authenticated ) {
                    appHistory.replace( '/home' );
                } else {
                    appHistory.replace( '/login' );
                }

                return false;
            }
        }

        // prevent going to the same route over and over.
        if ( history.action !== 'POP' && location.pathname === nextProps.location.pathname && location.key !== nextProps.location.key ) {
            appHistory.goBack();

            return false;
        }

        return this.isRouteLoaded( history.location.pathname );
    }

    UNSAFE_componentWillUpdate( nextProps ) {//eslint-disable-line
        const { location } = this.props;
        const { loaded } = nextProps;

        // set previousLocation if props.location is not modal
        if ( nextProps.history.action !== 'POP' && ( !this.isModal( location ) ) ) {

            this.previousLocation = this.props.location;
            this.previousScrollY = window.pageYOffset;
        }

        if ( this.isModal( nextProps.location ) ) {
            document.body.classList.add( 'modal-open' );
        } else {
            document.body.classList.remove( 'modal-open' );
        }

        if ( !loaded ) {
            document.body.classList.add( 'loading' );
        } else {
            document.body.classList.remove( 'loading' );
        }

        // keep track of the history since it isn't accessible through the history object.
        if ( this.locationHistory.length == 0 ||
            this.locationHistory[ this.locationHistory.length - 1 ].key !== nextProps.location.key ) {
            this.locationHistory.push( {
                key: nextProps.location.key,
                pathname: nextProps.location.pathname
            }
            );
        }
    }

    componentDidUpdate( prevProps ) {
        const path = this.props.location.pathname;

        if ( path !== prevProps.location.pathname ) {
            window.scrollTo( 0, 0 );
            // this.resetFocus();
            // TODO: Reset focus once I know which element to focus

            this.updatePageTitle( path );
        }
    }

    doPathsMatch = ( path1, path2 ) => {
        return ( path1 === path2 ||
            ( path1.indexOf( ':' ) >= 0 && path2.indexOf( ':' ) >= 0 &&
                path2.slice( 0, path2.indexOf( ':' ) ) === path1.slice( 0, path1.indexOf( ':' ) ) )
        );
    };

    isModal = ( location ) => {
        if ( location !== undefined && location !== null ) {
            const route = routes.find( ( route ) => route.modal && this.doPathsMatch( route.path, location.pathname ) );

            return route !== undefined && route !== null;
        } else {
            return false;
        }
    };

    isRouteLoaded = ( pathname, preLoad ) => {
        const route = routes.find( ( route ) => this.doPathsMatch( route.path, pathname ) );

        if ( route && !route.component ) {
            if ( !route.loading ) {
                // if the route is being pre-loaded, don't stop it from being loaded on a route change.
                if ( !preLoad ) {
                    route.loading = true;
                }

                const ComponentFactory = ( Component ) => (
                    ( props ) => (
                        <Component { ...props } />
                    )
                );

                route.onLoad( ( asyncModule ) => {
                    route.loading = false;
                    route.component = ComponentFactory(
                        asyncModule.default ? asyncModule.default : asyncModule
                    );

                    if ( !preLoad ) {
                        this.forceUpdate();

                        window.scrollTo( 0, 0 );
                    }
                } );
            }

            return false;
        }

        return true;
    };

    resetFocus = () => {
        const resetFocusItem = document.getElementsByTagName( 'h1' )[ 0 ];
        resetFocusItem.setAttribute( 'tabindex', '-1' );
        resetFocusItem.style.outline = 'none';
        resetFocusItem.focus();
    };

    updatePageTitle = path => {
        const pageTitles = {
            '/activation': this.props.activationTitle,
            '/login': this.props.loginTitle,
            '/forgot-user-id': this.props.forgotUserIdTitle,
            '/forgot-password': this.props.forgotPasswordTitle,
            '/reset-password': this.props.resetPasswordTitle,
            '/home': this.props.homeTitle,
            '/profile': this.props.profileTitle,
            '/rules': this.props.rulesTitle,
            '/contact': this.props.contactTitle,
            '/activity-history': this.props.activityHistoryTitle,
            '/faqs': this.props.faqsTitle,
            '/privacy-shield': this.props.privacyPolicyTitle,
            '/privacy-notice': this.props.privacyNoticeTitle,
            '/error': this.props.errorTitle,
        };

        document.title = pageTitles[ path ];
    };

    render() {
        const { location, history, authenticated, loaded, savePrivacyAcknowledgment, userData } = this.props;
        const appClasses = classNames( {
            'app-container': true,
            'authenticated': authenticated
        } );
        const isModal = this.isModal( location );
        const pageStyle = ( isModal ? { transform: 'translateY(-' + this.previousScrollY.toString() + 'px)' } : null );

        // spoof the previousLocation if the site loads on a modal route.
        if ( isModal && loaded && !this.previousLocation ) {
            this.previousLocation = {
                hash: '',
                key: 'p4r3q0',
                pathname: ( authenticated ? '/home' : '/login' ),
                search: '',
                state: undefined
            };
        }

        return (
            <div className={ appClasses } aria-hidden={ !loaded } >
                <Header />

                { loaded &&
                    <CSSTransitionGroup className="page-container"
                        transitionName="page-animate"
                        transitionEnterTimeout={ 800 }
                        transitionLeaveTimeout={ 400 }>
                        <div key={ ( isModal ? this.previousLocation : location ).pathname } style={ pageStyle } aria-live="assertive">
                            <Switch location={ isModal ? this.previousLocation : location } >
                                {
                                    routes.filter( ( route ) => !route.modal ).map( ( route, index ) =>
                                        <PageRoute key={ route.path } exact={ !route.default } path={ route.path }
                                            component={ route.component } location={ location } history={ history }
                                            allowAnonymous={ route.allowAnonymous } allowAuthenticated={ route.allowAuthenticated }
                                            onEnter={ route.onEnterAction ? () => this.props.dispatch( route.onEnterAction() ) : () => { } }
                                            authenticated={ authenticated } loaded={ loaded } />
                                    )
                                }
                            </Switch>
                        </div>
                    </CSSTransitionGroup>
                }

                <Footer privacyNotice={ userData.privacyNotice || {} } />

                { loaded &&
                    <CSSTransitionGroup className="modal-container"
                        transitionName="modal-animate"
                        transitionEnterTimeout={ 300 }
                        transitionLeaveTimeout={ 300 }>
                        { isModal &&
                            <Modal key={ location.key }>
                                <div className="content" aria-live="assertive">
                                    {
                                        routes.filter( ( route ) => route.modal ).map( ( route, index ) =>
                                            <Route key={ route.path } path={ route.path } component={ route.component } location={ location } />
                                        )
                                    }
                                </div>
                            </Modal>
                        }
                    </CSSTransitionGroup>
                }

                <CookieNotice
                    loaded={ loaded }
                    privacyNotice={ userData.privacyNotice || {} }
                    handleAcknowledge={ savePrivacyAcknowledgment }
                    cookieNoticeContent={ this.props.cookieNoticeContent } />

                <ActivityIndicator visible={ !loaded } />
            </div>
        );
    }
}

// These are page titles from CMMO that will update the document title on route change or rerender.
AppRoute = connect(
    state => ( {
        activationTitle: Locale.getString( state, 'common.docTitles.activation' ),
        loginTitle: Locale.getString( state, 'common.docTitles.login' ),
        forgotUserIdTitle: Locale.getString( state, 'common.docTitles.forgotUserId' ),
        forgotPasswordTitle: Locale.getString( state, 'common.docTitles.forgotPassword' ),
        resetPasswordTitle: Locale.getString( state, 'common.docTitles.resetPassword' ),
        homeTitle: Locale.getString( state, 'common.docTitles.home' ),
        profileTitle: Locale.getString( state, 'common.docTitles.profile' ),
        rulesTitle: Locale.getString( state, 'common.docTitles.rules' ),
        contactTitle: Locale.getString( state, 'common.docTitles.contact' ),
        activityHistoryTitle: Locale.getString( state, 'common.docTitles.activityHistory' ),
        faqsTitle: Locale.getString( state, 'common.docTitles.faqs' ),
        privacyPolicyTitle: Locale.getString( state, 'common.docTitles.privacyPolicy' ),
        privacyNoticeTitle: Locale.getString( state, 'privacy.notice.title' ),
        errorTitle: Locale.getString( state, 'common.docTitles.error' ),
        cookieNoticeContent: Locale.getString( state, 'cookie.notice.message' )
    } ),
    {
        savePrivacyAcknowledgment
    }
)( AppRoute );

class PageRoute extends React.Component {
    constructor( props ) {
        super( props );
        this.onEnterTriggered = false;
    }

    UNSAFE_componentWillReceiveProps() { //eslint-disable-line
        const {
            location,
            path,
            onEnter
        } = this.props;

        if ( location.pathname === path && onEnter && !this.onEnterTriggered ) {
            onEnter();
            this.onEnterTriggered = true;
        } else if ( location.pathname !== path ) {
            this.onEnterTriggered = false;
        }
    }

    render() {
        const {
            location,
            history,
            authenticated,
            component,
            exact,
            path,
            allowAnonymous,
            allowAuthenticated,
            loaded
        } = this.props;

        if ( loaded && authenticated && !allowAuthenticated && location.pathname === history.location.pathname ) {
            return <Redirect to="/home" push />;
        } else if ( loaded && !authenticated && !allowAnonymous && location.pathname === history.location.pathname ) {
            return <Redirect to="/login" push />;
        }

        return <Route exact={ exact } path={ path } render={ component } location={ location } />;
    }
}


/*******************************************************************************
 *  2. Connect App component to the Redux store
 */

App = connect(
    // mapStateToProps
    ( state ) => {
        return {
            ...state,
            authenticated: state.userData.authenticated,
            strings: state.clientData.bundleList[ state.userData.locale ],
            errors: Errors.getByType( state, Errors.ERROR_CLIENT_FETCHCLIENTDATA ),
        };
    },
    // mapDispatchToProps
    ( dispatch ) => ( {
        // setUserLocale,
        // validateSession,
        getSessionUserData: ( defaultLocale ) => dispatch( getSessionUserData( defaultLocale ) ),
        getSessionBundleData: ( bundle ) => dispatch( getSessionBundleData( bundle ) ),
        fetchClientData: () => dispatch( fetchClientData() ),
        fetchCatalogUrl: ( type ) => dispatch( fetchCatalogUrl( type ) ),
        dispatch: dispatch
    } )
)( App );


/*******************************************************************************
 * 4. Render the the app
 */

render(
    <Provider store={ AppStore() }>
        <App />
    </Provider>,
    document.getElementById( 'app-root' )
);




/* A simple templating method based on Douglas Crockford's supplant. */
/* This method replaces all instances of the ${key} pattern with the */
/* corresponding key's value on the object passed into it. it also uses */
/* the pattern [key: text ${key} text] to signify repetition */
/* patterns. The inner text of the pattern is repeated N times, where N */
/* is the number of items at the key. A zero length array, null, */
/* undefined or empty string on the key removes the pattern entirely. */
/* Otherwise an array containing strings or objects gets applied */
/* recursively to the inner text pattern. */
/* https://gist.github.com/Breton/2497986 */
if ( !String.prototype.template ) {
    String.prototype.template = function ( o ) {
        const tag = /\$\{([^}]*)\}/g;
        const many = /\[([a-zA-Z$_][a-zA-Z$_0-9]*?):([^\]]*)\]/g;

        function promote( v, b ) {
            let tmp;
            if ( typeof v !== 'object' ) {
                tmp = {};
                tmp[ b ] = v;
                v = tmp;
            }

            return v;
        }

        function rmany( a, b, c ) {
            let r = ( o[ b ] === 0 ? 0 : o[ b ] || [] ), i, set;
            r = promote( r, b );
            if ( typeof r.length !== 'number' ) {
                r = [ r ];
            }

            for ( i = 0, set = []; i < r.length; i += 1 ) {
                r[ i ] = promote( r[ i ], b );
                set[ i ] = c.template( r[ i ] );
            }

            return set.join( '' );
        }

        function rtag( a, b ) {
            const r = o[ b ];
            return typeof r === 'string' || typeof r === 'number' ? r : '';
        }

        return this.replace( many, rmany ).replace( tag, rtag );
    };
}

// Conditionally enable hot module reloading
if ( module.hot ) {
    module.hot.accept();
}
